import React, { Component, createContext, useReducer, useState } from "react";
import moment from "moment";
import http from "../utils/api";
import localforage from "../utils/localforage";
import PendencyObj, { SendPendencyAsync } from "../models/pendency";
import formatDate from "../utils/formatDate";
import { resolveDate } from "../utils/dateUtils";
import { withNotification } from "./NotificationContext";
import { withDialog } from "./DialogContext";
import { getHorasMes } from "../provider/system.service";
import Pendency from "../forms/Pendency";
import { getColaborador } from "../utils/storage";
import { withFb } from "./FbProvider";
import { makeStyles } from "@material-ui/styles";
import { getCurrentTOTP } from "../utils/totpGenerator";
import processHoursPerDay from "../components/hooks/processHoursPerDay";
import { getSaldoHorasDia } from "../provider/saldo-horas-dia.service";

export const Context = createContext({});

const useStyles = makeStyles({
  root: {
    height: "100%",
    display: "flex",
    maxHeight: "100vh",
    flexDirection: "column",
    maxWidth: "100vw",
  },
});

const Provider = (props) => {
  const [list, setList] = useState([]);
  const [hoursPerDay, setHoursPerDay] = useReducer(
    processHoursPerDay,
    list,
    (array) => processHoursPerDay(null, array)
  );
  const classes = useStyles();

  const setFilterDay = function ({
    dataHoraInicio = moment(),
    dataHoraFim = moment(),
  }) {
    return {
      dataHoraInicio: formatDate(moment(dataHoraInicio).startOf("day")),
      dataHoraFim: moment(dataHoraFim).isValid()
        ? formatDate(moment(dataHoraFim).endOf("day"))
        : null,
    };
  };

  const filter = (initial, newData, isCloseModal = true) => {
    delete newData.requestMessage;
    delete newData.status;

    let filterApontamento = {
      ...newData,
      ...setFilterDay(newData),
    };

    localforage.getItem("liderado").then((ld) => {
      if (ld && ld.codigoLiderado) {
        filterApontamento.codigoLiderado = ld.codigoLiderado;
        filterApontamento.nomeLiderado = ld.nomeLiderado;
      }
    });

    http
      .get("apontamentos", {
        params: filterApontamento,
      })
      .then(async ({ data }) => {
        if (data.data.length > 0) {
          if (isCloseModal) {
            props.dialog.close();
          }
        } else {
          props.notification.notify({
            message: "Não existem apontamentos no período filtrado!",
            color: "warning",
          });
        }
        localforage.setItem("apontamentos", data.data).then(() => {
          setList(data.data);
        });
      })
      .catch((err) => {
        const { response } = err;
        const data = response.data;
        newData.requestMessage = data?.error?.description;
        newData.status = "error";
        props.notification.notify({ message: newData.requestMessage });
      })
      .finally(async () => {
        if (newData.ticketFreshdesk) {
          filterApontamento.pendenciaId = filterApontamento.ticketFreshdesk;
          delete filterApontamento.ticketFreshdesk;
          delete filterApontamento.codigoProjeto;
          delete filterApontamento.codigoSubsistema;
        }
        localforage.setItem("filter-apontamento", filterApontamento).then();
        await getHorasMes({});
        let saldoHorasDia = await getSaldoHorasDia();
        setHoursPerDay(saldoHorasDia);
      });
  };

  const errorNotify = (edit = true) =>
    props.notification.notify({
      message: `Erro ao ${edit ? "editar" : "enviar"} apontamento`,
    });

  const novo =
    (cb = () => {}, err = () => errorNotify(false)) =>
    async (initial, newData) => {
      newData = await resolveDate(newData);
      http
        .post(
          "apontamentos",
          { ...(await SendPendencyAsync(newData)), inserting: true },
          {
            headers: {
              "X-Application-Totp": getCurrentTOTP(newData.dataHoraInicio),
            },
          }
        )
        .then(
          async ({
            data: {
              data: { alertaHoraExtra },
            },
          }) => {
            props.notification.notify({
              message: "Apontado com sucesso!",
              color: "success",
            });

            if (alertaHoraExtra) {
              setTimeout(() => {
                if (
                  /Alerta Nível 1/gi.test(alertaHoraExtra) ||
                  /Alerta Nível 2/gi.test(alertaHoraExtra)
                ) {
                  props.notification.notify({
                    message: alertaHoraExtra,
                    color: "warning",
                  });
                }

                if (/Alerta Nível 3/gi.test(alertaHoraExtra)) {
                  props.notification.notify({
                    message: alertaHoraExtra,
                    color: "secondary",
                  });
                }

                if (
                  /Alerta Nível 4/gi.test(alertaHoraExtra) ||
                  /Alerta Nível 5/gi.test(alertaHoraExtra)
                ) {
                  props.notification.notify({
                    message: alertaHoraExtra,
                    color: "error",
                  });
                }
              }, 3000);
            }

            filter({}, setFilterDay(newData), false);
            await localforage.setItem("novo-apontamento", {
              ...(await SendPendencyAsync(newData)),
              caminhoArquivo: null,
            });
            await getHorasMes({});
            cb();
          }
        )
        .catch(async (error) => {
          const { response } = error;
          const data = response.data;
          newData.requestMessage = data?.error?.description;
          newData.status = "error";
          await localforage.setItem("novo-apontamento", newData);
          err();
        });
    };
  const remove = (pendency) =>
    http
      .delete("apontamentos", {
        params: {
          dataHoraInicio: pendency.dataHoraInicio,
        },
        headers: {
          "X-Application-Totp": getCurrentTOTP(pendency.dataHoraInicio),
        },
      })
      .then(async () => {
        props.notification.notify({
          message: "Removido com sucesso!",
          color: "success",
        });
        const filterApontamento = await localforage.getItem(
          "filter-apontamento"
        );
        filter({}, { ...setFilterDay(filterApontamento) });
      })
      .catch(() => {
        props.notification.notify({
          message: "Não foi possível excluir o apontamento.",
        });
      })
      .finally(async () => {
        props.dialog.close();
        props.dialog.submiting(false);
        await getHorasMes({});
      });

  const addPendencyDialog = async ({
    isNew = false,
    error = false,
    data,
    nomeLiderado,
    onSuccess = () => {
      addPendencyDialog({});
    },
  }) => {
    let autoFocus = false;
    let newPendency =
      (await localforage.getItem("novo-apontamento")) ??
      props.data.pendency ??
      PendencyObj;
    if (isNew) {
      newPendency.status = null;
      newPendency.requestMessage = "";
      newPendency.dataHoraFim = "";
    }
    if (error)
      newPendency.dataHoraInicio = formatDate(
        moment(newPendency.dataHoraInicio)
      );
    if (!isNew && !error) {
      newPendency.status = null;
      newPendency.requestMessage = null;
      newPendency.dataHoraInicio = formatDate(moment(newPendency.dataHoraFim));
      newPendency.dataHoraFim = "";
      autoFocus = true;
    }
    if (data) {
      newPendency = {
        ...newPendency,
        dataHoraInicio: formatDate(moment(data)),
      };
    }
    props.dialog.open({
      noActionButtons: true,
      title: "Adicionar Apontamento " + (nomeLiderado ? nomeLiderado : ""),
      content: (
        <Pendency
          data={newPendency}
          disableCloseOnSubmit={true}
          dateTime
          isNew={isNew}
          autoFocus={autoFocus}
          withError={error}
          onSubmit={novo(
            () => {
              onSuccess();
            },
            () => {
              addPendencyDialog({ isNew: false, error: true });
            }
          )}
        />
      ),
      size: "md",
    });
  };

  const editSubmit = async (initialValues, pendency, form) => {
    pendency = await resolveDate(pendency);
    var codigoColaboradorOrigem = "";
    codigoColaboradorOrigem = getColaborador().codigoColaborador;
    await localforage.getItem("liderado").then((ld) => {
      if (ld && ld.codigoLiderado) {
        codigoColaboradorOrigem = ld.codigoLiderado;
      }
    });
    http
      .post(
        "apontamentos",
        {
          ...(await SendPendencyAsync(pendency)),
          codigoColaboradorOrigem,
          codigoAreaOrigem: getColaborador().area,
          dataHoraInicioOrigem: initialValues.dataHoraInicio,
        },
        {
          headers: {
            "X-Application-Totp": getCurrentTOTP(pendency.dataHoraInicio),
          },
        }
      )
      .then(() => {
        props.dialog.close();
        props.notification.notify({
          message: "Apontamento atualizado com sucesso!",
          color: "success",
        });
        filter({}, { ...setFilterDay(pendency) });
      })
      .catch((err) => {
        const { response } = err;
        const data = response.data;
        const msg = data?.error?.description;
        props.notification.notify({
          message: `Erro ao editar apontamento. ${msg ? msg : ""}`,
        });
        props.dialog.close();
      });
       await getHorasMes({});
  };

  const dataContext = {
    filter,
    new: novo,
    list,
    setList,
    hoursPerDay,
    setHoursPerDay,
    remove,
    editSubmit,
    errorNotify,
    addPendencyDialog,
    processHoursPerDay,
  };

  return (
    <Context.Provider value={dataContext}>
      <div className={classes.root}>{props.children}</div>
    </Context.Provider>
  );
};

export const ApontamentoProvider = withFb(
  withDialog(withNotification(Provider))
);

const { Consumer } = Context;

export const withApontamento = (Child) =>
  class WithPendency extends Component {
    render() {
      return (
        <Consumer>
          {(apontamentos) => (
            <Child {...this.props} apontamentos={apontamentos} />
          )}
        </Consumer>
      );
    }
  };
